import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginService } from 'app/Login/Services/login.service';
import { ImageService } from '../Services/image.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(private router: Router, private loginService: LoginService, private imgService: ImageService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const keepConnected = localStorage.getItem('keep-connected');
        const isMaster = localStorage.getItem('profile_name') === '7d4e9f24-17e8-11ec-9621-0242ac130002';
        const isMasterAssociate = localStorage.getItem('profile_name') === '7415bb4a-c1e9-401d-870a-7af65a8e3acd';
        if (keepConnected != null) {
            if (keepConnected === 'false') {
                if (!sessionStorage.getItem('id-token')) {
                    const storedUsers = localStorage.getItem('strdUsr');
                    localStorage.clear();
                    // this.imgService.deleteCacheThumb();
                    localStorage.setItem('strdUsr', storedUsers);
                    sessionStorage.clear();
                    this.loginService.navSideShowEmitter.emit(false);
                    this.router.navigate(['/login/signin'], { queryParams: { returnUrl: state.url } });
                    return false;
                }
                else {
                    if ((isMaster || isMasterAssociate) && state.url === '/home') {
                        this.router.navigate(['/users/partners']);
                        return false;
                    }

                    return true;
                }
            }
            else {
                if (localStorage.getItem('id-token') != null) {
                    if ((isMaster || isMasterAssociate) && state.url === '/home') {
                        this.router.navigate(['/users/partners']);
                        return false;
                    }

                    return true;
                }
                else {
                    const storedUsers = localStorage.getItem('strdUsr');
                    localStorage.clear();
                    // this.imgService.deleteCacheThumb();
                    localStorage.setItem('strdUsr', storedUsers);
                    sessionStorage.clear();
                    this.loginService.navSideShowEmitter.emit(false);
                    this.router.navigate(['/login/signin'], { queryParams: { returnUrl: state.url } });
                    return false;
                }
            }
        }
        else {
            const storedUsers = localStorage.getItem('strdUsr');
            localStorage.clear();
            // this.imgService.deleteCacheThumb();
            localStorage.setItem('strdUsr', storedUsers);
            sessionStorage.clear();
            this.loginService.navSideShowEmitter.emit(false);
            this.router.navigate(['/login/signin'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}
